export const ta = {
  msg:
    {
      'username': 'பயனர் பெயர்',
      'password': 'கடவுச்சொல்',
      'login': 'நுழைக',
      'username_not_found': 'தயவு செய்து உங்கள் பயனர்பெயரைக் குறிப்பிடவும்.',
      'password_not_found': 'தங்கள் கடவுச் சொல்லைப் பதிவு செய்யவும்.',
      'error': 'தவறான பயனர்பெயர் அல்லது கடவுச்சொல்.',
      'changeLanguage': '',
      'lang-en': 'English',
      'lang-ms': 'Bahasa Melayu',
      'lang-zh': 'Chinese',
      'lang-ta': 'Tamil',
      'lang-km': 'Khamer',
      'submit_button_text': 'அனுப்புக',
      'enter': 'நுழைக',
      'en': 'English',
      'ms': 'Bahasa Melayu',
      'zh': 'Chinese',
      'ta': 'Tamil',
      'km': 'Khmer',
      'th': 'Thai',
      'id': 'Bahasa Indonesia',
      'ar': 'Arabic',
      'blank_username_field': 'தயவு செய்து உங்கள் பயனர்பெயரைக் குறிப்பிடவும்.',
      'blank_password_field': 'தங்கள் கடவுச் சொல்லைப் பதிவு செய்யவும்.',
      'invalid_credentials': 'தவறான பயனர்பெயர் அல்லது கடவுச்சொல்.',
      'copyright': 'ஆக்கம் Global Psytech'
    }
}
